// src/components/shell/popovers/ActivityBannerImpersonationStrip.tsx
// Thin contrasting bar rendered inside ActivityBannerPopover whenever dev
// impersonation is enabled. Together with the sidebar ImpersonationPopover
// (editor surface), this strip serves as the persistent active indicator per
// doctrine D1. The legacy standalone banner has been removed.
import { clearDevImpersonation } from "@/lib/devImpersonationStorage";
import type { DevImpersonationV1 } from "@/lib/devImpersonationStorage";

export type ActivityBannerImpersonationStripProps = {
  impersonation: DevImpersonationV1;
};

export function ActivityBannerImpersonationStrip({ impersonation }: ActivityBannerImpersonationStripProps) {
  return (
    <div className="border-t border-amber-200 bg-amber-50/95 px-4 py-2 text-[11px] text-amber-900 dark:border-amber-700 dark:bg-amber-950/80 dark:text-amber-100">
      <div className="flex flex-wrap items-center gap-2">
        <span className="font-semibold uppercase tracking-wide">Impersonating</span>
        <span>{impersonation.roles.join(", ") || "—"}</span>
        {impersonation.workspaceBrowseAllOrgs ? (
          <span className="rounded-full border border-amber-300 bg-white/70 px-2 py-0.5 text-[10px] font-semibold dark:border-amber-700 dark:bg-amber-900/40">
            Browse any org
          </span>
        ) : null}
        {impersonation.trustLevelOverride ? (
          <span className="rounded-full border border-amber-300 bg-white/70 px-2 py-0.5 text-[10px] font-semibold dark:border-amber-700 dark:bg-amber-900/40">
            Trust L{impersonation.trustLevelOverride}
          </span>
        ) : null}
        <button
          type="button"
          onClick={() => clearDevImpersonation()}
          className="ml-auto rounded-md border border-amber-300 bg-white px-2 py-0.5 text-[10px] font-semibold hover:bg-amber-100 dark:border-amber-700 dark:bg-amber-900/40"
          title="Clear dev impersonation"
        >
          Clear
        </button>
      </div>
    </div>
  );
}
